module.exports = "//static.hsappstatic.net/salesImages/static-1.403/self-service/upgrade/upgrade-meetings.png"